const gtm = require("common/analytics/google-tagmanager");


const composeTrackFocus = (fieldName) => {
  return () => {
    gtm.trackEventAsync({
      category: "register_page",
      property: fieldName,
      action: "focus"
    });
  };
};

const composeTrackToggle = (fieldName) => {
  return ($input) => {
    gtm.trackEventAsync({
      category: "register_page",
      property: fieldName,
      action: $input.is(":checked") ? "select" : "deselect"
    });
  };
};

const trackSubmitClick = () => {
  return gtm.trackEventAsync({
    category: "register_page",
    property: "submit_button",
    action: "click"
  });
};

module.exports = {
  email: composeTrackFocus("email_field"),
  password: composeTrackFocus("password_field"),
  firstName: composeTrackFocus("first_name_field"),
  lastName: composeTrackFocus("last_name_field"),
  postalRef: composeTrackFocus("postcode_field"),
  newsletter: composeTrackToggle("newsletter_opt_in"),
  genderMale: composeTrackToggle("gender_male"),
  genderFemale: composeTrackToggle("gender_female"),
  submit: trackSubmitClick
};
